// EkipRolleri.js — BACAK BAŞINA EKİP ROLLERİ (29 Eyl 2026)
//
// 🔑 Serkan (29 Eyl, kâğıt OFP girerken): *"İki bacaklı kombinasyonlarda elle
//    veri girerken PF/PM her bacak için seçilebilsin."* · *"4 bacak uçuş
//    girilse dahi her bacak için ayrı ayrı edit edilebilmeli."* · *"Hem PF hem
//    PM hem de varsa CRZ pilot görevleri kayıt altına alınacak ki SHT-FTL
//    hesabı yapılabilsin."*
//
// 🔴 ÖLÇÜLEN ESKİ HÂL: rol pilot başına BİR KEZ seçiliyordu (ASSIGN'da tablo
//    tıklaması, EDIT'te pilot satırındaki tek kutu) ve BÜTÜN bacaklara aynen
//    yazılıyordu. Veri (`crew_duties.sectors[].role`) bacak başına rolü zaten
//    taşıyordu; eksik olan onu SEÇECEK yerdi. FCL.060 yakınlığı PF bacaklarını
//    saydığı için bacakta yanlış rol = yanlış yakınlık.
//
// 🔴 KÂĞIT OFP KAYDI TEK PİLOT YAZIYORDU (7 Eyl'den beri). Yazıcı ekibin
//    yalnız bir satırını alıyordu; o pilot PF ise yalnız `pf_pilot`, PM ise
//    yalnız `pm_pilot` doluyordu. Öteki pilot STATISTICS'te yoktu. Tasarım,
//    her pilotun kendi görevini ayrı kapatacağını varsaymıştı; ekranlar ise
//    ekibi tek seferde kapatıyor. Artık yazıcı EKİBİN TAMAMINI alır ve her
//    bacağın PF/PM/CRZ'sini ekipten okur (`bacakPilotlari`).
//
// KURALLAR (tek yer — ASSIGN, EDIT ve kâğıt OFP yazıcısı bunu çağırır, İlke 3):
//   · Her uçuş bacağında TAM BİR PF.
//   · İki ve daha fazla pilotta TAM BİR PM.
//   · Kalan pilotlar CRZ CPT — en fazla İKİ (`AZAMI_CRZ`, 5 Eki 2026): SHT-FTL/HG
//     Md.11(4) yalnız iki durumu tanımlar (bir ilave pilot +2 saat, iki ilave
//     pilot +3 saat) → ekip en çok 4 pilot. CHECK RIDE denetçisi şirket pilotu
//     değildir, burada yoktur.
//   · Rol değiştirmek TAKASTIR: bir pilota PF verilince eski PF onun eski
//     rolünü alır. Böylece bacak hiçbir an geçersiz kalmaz ("öteki pilot
//     otomatik PM").
//   · DH (konumlandırma) bacağının rolü yoktur — harita `null`.

export const ROLLER = ['PF', 'PM', 'CRZ CPT'];
// 🔑 Serkan (5 Eki 2026): *"velevki 4 pilot olduk … roller PF, PM, CRZ, CRZ diye gider"* — Md.11(4) iki ilave pilot.
// 🔴 Önce sınır BİRDİ: 4 pilotlu ekip hiçbir ekranda kurulamıyordu, +3 saat hiç uygulanmıyordu.
export const AZAMI_CRZ = 2;

const buyuk = (r) => String(r || '').trim().toUpperCase();

/** Bir üyenin sektör listesinde, verilen sektörün eşi — `seq` ile, yoksa sırayla.
 *  ASSIGN'ın kâğıt çağrısı DH bacaklarını ayıklayıp gönderir; sıra kayar ama
 *  `seq` kaymaz. */
export function sektorEsi(liste, sektor, i) {
  const l = liste || [];
  if (sektor?.seq != null) {
    const e = l.find(x => x?.seq === sektor.seq);
    if (e) return e;
  }
  return l[i];
}

/** Bir bacak haritasında `key`e `rol` verir; o rolü taşıyan öteki üye
 *  `key`in ESKİ rolünü alır (takas). Harita hiçbir an geçersiz kalmaz.
 *  `sahibiKey`: rolü iki üye taşıyorsa (iki CRZ CPT, 5 Eki 2026) takasın KİMLE
 *  yapılacağı — tablonun o sütununun sahibi; verilmezse rolü taşıyan ilk üye. */
export function rolAta(harita, key, rol, sahibiKey = null) {
  if (!harita || !(key in harita)) return harita;
  const eski = harita[key];
  if (eski === rol) return harita;
  const y = { ...harita, [key]: rol };
  const sahibi = (sahibiKey && sahibiKey !== key && harita[sahibiKey] === rol) ? sahibiKey
    : Object.keys(harita).find(k => k !== key && harita[k] === rol);
  if (sahibi) y[sahibi] = eski;
  return y;
}

/** Bir bacak haritasının hatası — ADIYLA. `null` = geçerli.
 *  Eski kayıtlarda iki pilotun birden PF yazılı olduğu bacak olabilir (EDIT
 *  eskiden her rolü serbest seçtiriyordu); onu sessizce "düzeltmeyiz",
 *  gösteririz ve kayıt düzeltilmeden geçmez (İlke 2). */
export function bacakHatasi(harita) {
  const v = Object.values(harita || {}).map(buyuk);
  if (!v.length) return 'NO CREW';
  const say = (r) => v.filter(x => x === r).length;
  const bilinmeyen = v.filter(x => !ROLLER.includes(x));
  if (bilinmeyen.length) return `UNKNOWN ROLE (${bilinmeyen.join(', ') || 'empty'})`;
  if (say('PF') !== 1) return `EXACTLY ONE PF REQUIRED (${say('PF')} selected)`;
  if (v.length >= 2 && say('PM') !== 1) return `EXACTLY ONE PM REQUIRED (${say('PM')} selected)`;
  if (say('CRZ CPT') > AZAMI_CRZ) return `AT MOST ${AZAMI_CRZ} CRZ CPT — SHT-FTL/HG Md.11(4) (${say('CRZ CPT')} selected)`;
  return null;
}

/** Üyelerin kendi sektör dizilerinden bacak bacak rol haritası kurar.
 *  @param sektorler  bacak listesi (DH bacağı `deadhead: true`)
 *  @param uyeler     [{ key, sectors }] — her üyenin KENDİ sektör dizisi
 *  @returns [{ [key]: rol } | null] — DH bacağı `null` */
export function haritalariKur(sektorler, uyeler) {
  return (sektorler || []).map((s, i) => {
    if (s?.deadhead) return null;
    return Object.fromEntries((uyeler || []).map(u => {
      const kendi = sektorEsi(u.sectors, s, i);
      return [u.key, buyuk(kendi?.role) || null];
    }));
  });
}

/** Haritalardan herhangi birinde CRZ CPT var mı (augmented ekip, Md.11). */
export function crzVar(haritalar) {
  return (haritalar || []).some(h => h && Object.values(h).map(buyuk).includes('CRZ CPT'));
}

/** Aynı bacakta iki CRZ CPT var mı — 4 pilotlu ekip, Md.11(4) iki ilave pilot (5 Eki 2026). Motordaki
 *  `ekipBilgisi` ile AYNI tanım: farklı bacaklarda birer CRZ dörtlü ekip değildir (aynı anda değiller). */
export function dortPilotVar(haritalar) {
  return (haritalar || []).some(h => h && Object.values(h).map(buyuk).filter(r => r === 'CRZ CPT').length >= 2);
}

/** Herhangi bir bacakta CRZ CPT olan üyeler — FCL.060(a)(3) yakınlığı
 *  bu pilotlara bakar. */
export function crzUyeleri(haritalar) {
  const s = new Set();
  (haritalar || []).forEach(h => h && Object.entries(h).forEach(([k, r]) => {
    if (buyuk(r) === 'CRZ CPT') s.add(k);
  }));
  return [...s];
}

/** Ekip küçülünce (EDIT'te yeni eklenen üye kaldırılınca) kalan CRZ,
 *  kaldırılanın rolünü alır — bacak geçerli kalır. */
export function uyeCikar(haritalar, key) {
  return (haritalar || []).map(h => {
    if (!h || !(key in h)) return h;
    const giden = h[key];
    const y = { ...h };
    delete y[key];
    if (buyuk(giden) !== 'CRZ CPT') {
      const crz = Object.keys(y).find(k => buyuk(y[k]) === 'CRZ CPT');
      if (crz) y[crz] = giden;
    }
    return y;
  });
}

/** Ekibe üye eklenince her uçuş bacağında CRZ CPT olarak girer. */
export function uyeEkle(haritalar, key) {
  return (haritalar || []).map(h => (h ? { ...h, [key]: 'CRZ CPT' } : h));
}

/** Kâğıt OFP satırı için bir bacağın pilotları, ekibin TAMAMINDAN.
 *  @param ekip  [{ pilot_id, sectors }] — atamadaki her pilotun satırı
 *  @returns {{ pf, pm, crz, crz2, hata }} — aynı rolü iki pilot taşıyorsa (CRZ CPT'de ikiden fazla) `hata`
 *           ADIYLA döner; yazıcı yazmaz (sessizce birini seçmek, öbürünü
 *           kaybetmek olurdu).
 *  5 Eki 2026 (4 pilotlu ekip, Md.11(4)): ikinci CRZ `crz2` → `manual_flights.crz2_pilot`. 🔴 Önce iki CRZ "TWO PILOTS
 *  AS CRZ CPT" hatasıydı — 4 pilotlu kâğıt uçuş RECORD AS FLOWN'da reddediliyordu. */
export function bacakPilotlari(ekip, sektor, i) {
  const out = { pf: null, pm: null, crz: null, crz2: null, hata: null };
  const alan = { PF: 'pf', PM: 'pm', 'CRZ CPT': 'crz' };
  for (const u of ekip || []) {
    const kendi = sektorEsi(u.sectors, sektor, i);
    const ilkRol = (u.sectors || []).find(x => !x?.deadhead && x?.role)?.role;
    const r = buyuk(kendi?.role || ilkRol);
    const a = alan[r];
    if (!a || !u.pilot_id) continue;
    if (a === 'crz' && out.crz && out.crz !== u.pilot_id) {
      if (!out.crz2 || out.crz2 === u.pilot_id) { out.crz2 = u.pilot_id; continue; }
      out.hata = `${sektor?.dep || '?'}-${sektor?.dest || '?'}: MORE THAN ${AZAMI_CRZ} PILOTS AS CRZ CPT (SHT-FTL/HG Md.11(4))`;
      continue;
    }
    if (out[a] && out[a] !== u.pilot_id) {
      out.hata = `${sektor?.dep || '?'}-${sektor?.dest || '?'}: TWO PILOTS AS ${r}`;
      continue;
    }
    out[a] = u.pilot_id;
  }
  return out;
}

/** Bir sektör dizisinin rol özeti — iz satırında okunur biçimde. */
export function rolOzeti(sektorler) {
  return (sektorler || []).filter(x => !x?.deadhead)
    .map(x => `${x?.dep || '?'}-${x?.dest || '?'} ${buyuk(x?.role) || '—'}`).join(' · ');
}

/** Bir sektör dizisine bir üyenin bacak rollerini uygular (DH'ye dokunmaz).
 *  Saatler, rota, tip — rolden başka HİÇBİR alan değişmez: 29 Eyl'de
 *  bulunan kusurda rol yazımı sektörü ESKİ kayıttan yeniden kurup aynı
 *  kayıtta girilen yeni saatleri siliyordu. */
export function rolleriUygula(sektorler, haritalar, key) {
  return (sektorler || []).map((x, i) => {
    const h = (haritalar || [])[i];
    if (x?.deadhead || !h || !(key in h) || !h[key]) return x;
    return { ...x, role: h[key] };
  });
}
